import { useSelector } from 'react-redux';
import { selectConfigurationSingleBackgroundUpgrade } from '../../../../../../selectors';

const useOrderContainsSingleBackgroundUpgrade = (): boolean => {
  return useSelector(selectConfigurationSingleBackgroundUpgrade);
};

export default useOrderContainsSingleBackgroundUpgrade;
